import React, { useState, useEffect } from 'react';
import CommonFirstStepCard from './CommonFirstStepCard';
import styles from './UserKycStepOne.module.css';
import pancard_icon from '../../../images/icons/UserKycIcons/pancard_icon.svg';
import selfie_icons from '../../../images/icons/UserKycIcons/selfie_icons.svg';
import aadharCard_icon from '../../../images/icons/UserKycIcons/aadharCard_icon.svg';
import addressproof_icon from '../../../images/icons/UserKycIcons/addressproof_icon.svg';
import verified_icon from '../../../images/icons/UserKycIcons/verified_icon.svg';
import tealArrow from '../../../images/icons/UserKycIcons/tealArrow.svg';
import orangeArrow from '../../../images/icons/UserKycIcons/orangeArrow.svg';
import purpleArrow from '../../../images/icons/UserKycIcons/purpleArrow.svg';
import blueArrow from '../../../images/icons/UserKycIcons/blueArrow.svg';
import { useFormikContext } from 'formik';

function UserKycStepOne() {
  const { box } = styles;
  const { handleSubmit } = useFormikContext();

  function handleSelectData() {
    handleSubmit();
  }
  const initialDesign = [
    {
      img: pancard_icon,
      textColor: 'text-green-1000',
      bgColor: 'bg-green-100',
      ColoredArrow: tealArrow,
      step: 1,
      discription: "Let's start by uploading \n PAN card"
    },
    {
      img: selfie_icons,
      textColor: 'text-orange-800',
      bgColor: 'bg-orange-900',
      ColoredArrow: orangeArrow,
      step: 2,
      discription: "Let's take selfie now "
    },
    {
      img: aadharCard_icon,
      textColor: 'text-purple-100',
      bgColor: 'bg-purple-200',
      ColoredArrow: purpleArrow,
      step: 3,
      discription: 'Now Please Upload Aadhar card'
    },
    {
      img: addressproof_icon,
      textColor: 'text-blue-900',
      bgColor: 'bg-blue-100',
      ColoredArrow: blueArrow,
      step: 4,
      discription: 'Now Please Upload Current Address Proof'
    }
  ];
  return (
    <div className={`${box}`}>
      <p className="pb-5 text-black-500 font-roboto text-sm">
        Please keep the following document ready
        <br />
        for completing your e-KYC
      </p>
      {initialDesign.map((each, i) => {
        return (
          <CommonFirstStepCard
            key={i}
            sendeach={each}
            handleSelectData={() => {
              if (each.step == 1) {
                handleSelectData();
              }
            }}
          />
        );
      })}
    </div>
  );
}
export default UserKycStepOne;
